import React from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import "./style.css";

const DEFAULT_COLORS = [
  "#F1582E",
  "#003a8c",
  "#6366F1",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#3B82F6",
  "#8B5CF6",
  "#14B8A6",
  "#F43F5E",
  "#22C55E",
  "#EAB308",
];

const generateColors = (count) =>
  Array.from(
    { length: count },
    (_, i) => DEFAULT_COLORS[i % DEFAULT_COLORS.length]
  );

const parseValue = (val) => {
  if (typeof val === "number") return val;
  if (typeof val === "string") {
    const match = val.match(/[\d.]+/);
    return match ? parseFloat(match[0]) : 0;
  }
  return 0;
};

const BarChartComponent = ({
  title = "Judul Chart",
  dataSource = [],
  labelDataSource = [],
  height = 400,
  yAxisLabel = "Luas (ha)",
}) => {
  // Cegah mutasi dari data Redux (frozen object)
  const safeDataSource = JSON.parse(JSON.stringify(dataSource));
  const safeLabelDataSource = JSON.parse(JSON.stringify(labelDataSource));

  if (!Array.isArray(safeDataSource) || safeDataSource.length === 0)
    return null;

  const labels = safeDataSource.map((item) => item.label);
  const colors = generateColors(safeLabelDataSource.length);

  const datasets = safeLabelDataSource.map((groupLabel, index) => {
    const data = safeDataSource.map((item) => {
      if (Array.isArray(item.value)) {
        const match = item.value.find((v) => v.label === groupLabel);
        return match ? parseValue(match.value) : 0;
      }
      return item.label === groupLabel ? parseValue(item.value) : 0;
    });

    return {
      label: groupLabel,
      data,
      backgroundColor: colors[index],
    };
  });

  const chartData = {
    labels,
    datasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.parsed.y} ha`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: false,
        ticks: { maxRotation: 45, minRotation: 30 },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: yAxisLabel,
        },
      },
    },
  };

  return (
    <div className="custom-card-container">
      <div className="card-title-responsive">{title}</div>
      <div style={{ position: "relative", width: "100%", height }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default BarChartComponent;
